module.exports = __webpack_public_path__ + "stylesheets/newsWebsite_09daa1a7a72379b0985c68b962a904c7.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/newsWebsite.less
// module id = b/cW
// module chunks = 55